import script from "./Authenticated.vue?vue&type=script&setup=true&lang=js"
export * from "./Authenticated.vue?vue&type=script&setup=true&lang=js"

import "./Authenticated.vue?vue&type=style&index=0&id=125e40a8&lang=scss"

const __exports__ = script;

export default __exports__